import React from 'react'

/**
 * Descendant fields report error state here. A collapsed section auto-expands on error;
 * nested sections cascade their aggregate upward.
 */
export interface IUI2FormSectionErrorContext {
  reportError: (id: string, hasError: boolean) => void
}

const noop: IUI2FormSectionErrorContext = { reportError: () => undefined }

export const UI2FormSectionErrorContext = React.createContext<IUI2FormSectionErrorContext>(noop)
